// 键盘快捷键的共用判断。
// ------------------------------------------------------------------
// 画布（空格抓手 / Delete 删除）与全局（Ctrl+Z 撤销）都要先问这一句：
// 用户正在详情面板里敲公差时，按空格是打分隔、按退格是删字符、按 Ctrl+Z 是
// 撤销这次输入 —— 劫持过去就成了「打着字把图纸上的气泡删了」。
//
// 放在 lib/ 而不是各组件内：曾经因为焦点判断只写在 Canvas 里，App 级快捷键
// 拿不到它，最后只能在同一处重复实现，两边的判断迟早会漂移。

/** 事件目标是否为会吃键盘输入的控件（输入框 / 文本域 / 下拉 / 可编辑区）。 */
export function isTypingTarget(el: EventTarget | null): boolean {
  const t = el as HTMLElement | null;
  if (!t) return false;
  const tag = (t.tagName || '').toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select'
         || t.isContentEditable === true;
}

/**
 * 把键盘焦点从输入控件上收回。画布在 pointerdown 里调用。
 *
 * 为什么必须显式做：浏览器本来会在 mousedown 落在非可聚焦元素时自动失焦，
 * 但画布的 `preventDefault()`（为了不让拖拽选中文字）**把这个默认失焦一并阻止了**。
 * 后果：用户在详情面板改完「公称值」→ 点一个气泡 → 按 Delete，
 * keydown 的 target 仍是那个输入框 → 被 isTypingTarget 挡下 → 删除静默失效。
 * 而「改字段再删气泡」正是最常用的操作序列。
 */
export function blurTypingTarget(): void {
  const el = document.activeElement as HTMLElement | null;
  if (el && isTypingTarget(el)) el.blur();
}

/** Ctrl+Z / ⌘Z（不带 shift/alt）。 */
export function isUndoCombo(e: KeyboardEvent): boolean {
  return (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey
         && (e.key === 'z' || e.key === 'Z');
}
